import { Avatar, Dialog } from "@mui/material";
import React, { useState, useEffect } from "react";
import { GET_USER_DETAILS_MORE_DETAILS } from "../../utils/constants";
import { getCommonDataBasedOnId } from "../store/customer/CustomerSocialAddUpdateFunction";
import useRequireAuth from "../../utils/useRequireAuth";
import { getInitials, getName } from "../../utils/utilityFunctions/stringUtility";
import SouthIcon from "@mui/icons-material/South";
import { deepOrange, deepPurple } from "@mui/material/colors";
import { ReactComponent as ForwardAngleBracket } from "../../assets/images/forwardAngleBracket.svg";
import { ReactComponent as Mail } from "../../assets/images/icons/mail.svg";
import { ReactComponent as Phone } from "../../assets/images/icons/phone.svg";
import { ReactComponent as RepotingManager } from "../../assets/images/icons/RepotingManager.svg";
import { Drawer } from "@mui/material";
import CustomDrawer from "../UniversalComponents/CustomDrawer";
import { showLoader, hideLoader } from "../../utils/loaderSlice";
import { useDispatch } from "react-redux";
import AvatarName from "../UniversalComponents/AvatarName";
import moment from "moment";
import CopyIconComponent from "../UniversalComponents/CopyIconComponent";
import { ReactComponent as NewCancel } from "../../assets/images/NewCancel.svg";
import { CrossIcon } from "lucide-react";
import { ReactComponent as EditPencil } from "../../assets/images/newPencilEdit.svg";
import { ReactComponent as LineIcon } from "../../assets/images/line.svg";

const Initials = ({ value }) => (
  <div className="h-7 w-7 sm:h-7 sm:w-7  flex items-center justify-center ">
    {/* <span className="text-xs text-gray-500">{getInitials(value)}</span> */}
    <AvatarName
      name={getInitials(value)}
      size="medium"
      bgColor={"#e8ecf299"}
      textColor={"#6b7280"}
      borderColor={"#ABABAC"}
    />
  </div>
);
const TeamCard = ({ name, designation, onClick, leader }) => {
  return (
    <div
      className={`border rounded-lg flex  ${leader ? "" : "cursor-pointer"} items-start p-2 gap-1 bg-[#F7F7F7] border-[#D9D9D9] group justify-between`}
      onClick={onClick}
    >
      <div className="rounded-full  font-medium text-lg text-[#ABABAC]">{<Initials value={name ? name : "-"} />}</div>
      <div className="flex flex-col">
        <p className="text-2C495D text-xs font-medium">{name ? name : "-"}</p>
        <p className="text-[#2999BC] text-xs font-small">{designation ? designation : "-"}</p>
      </div>
      <div className={`invisible ${leader ? "invisible" : "group-hover:visible"} `}>{<ForwardAngleBracket />}</div>
    </div>
  );
};
const CustomerShowDetails = ({
  open,
  onClose,
  Data,
  setOpenModal,
  setOpenShowDetails,
  setDetaillOpen,
  enableEditButton,
}) => {
  const [userInfo, setUserInfo] = useState(true);
  const [teamOpen, setTeamOpen] = useState(false);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const { token } = useRequireAuth();
  const [hierarchyData, setHierarchyData] = useState([]);

  console.log(Data, "Data");

  const fetchDataCustomerAccess = async (customerId, token) => {
    try {
      if (!customerId) return;

      setIsLoading(true);
      setUserInfo(true);
      setTeamOpen(false);

      const url = `${GET_USER_DETAILS_MORE_DETAILS}?uuid=${customerId}`;
      const response = await getCommonDataBasedOnId(url, token);

      if (response?.success) {
        setHierarchyData(response.data || []);
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error fetching customer access data:", error);
    }
  };

  useEffect(() => {
    if (isLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [dispatch]);

  const toggleState = (section) => {
    if (section === "userInfo") {
      setUserInfo(true);
      setTeamOpen(false);
    } else if (section === "teamOpen") {
      setUserInfo(false);
      setTeamOpen(true);
    }
  };

  useEffect(() => {
    const [userData, headerKey] = Data;
    let payload;
    if (headerKey === "reporting") {
      //replace
      // payload = userData?.manager_id?.value;
      payload = userData?.reporting_uuid;
    } else {
      payload = userData?.userUuid;
    }
    fetchDataCustomerAccess(payload, token);
  }, [Data]);
  const { user, manager, team } = hierarchyData;
  console.log(Data?.userData?.userUuid, "gghierarchyDatavinay");

  return (
    <>
      {open && (
        <CustomDrawer
          variant="temporary"
          anchor="right"
          disableBackdropClick={true}
          open={open}
          onClose={onClose}
          fullWidth
          maxWidth="md"
        >
          <div
            className=" h-full flex flex-col"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <div className="flex justify-between border-b-2 p-4 px-6 items-center">
              <div className="flex justify-between">
                <h3 className="text-lg text-[#1D4469] font-poppins font-500">Profile View</h3>
              </div>

              <div className="flex items-center justify-end gap-2">
                {enableEditButton && (
                  <div
                    className="rounded cursor-pointer"
                    onClick={() => {
                      setOpenModal(true);
                      setOpenShowDetails(false);
                      setDetaillOpen(false);
                    }}
                  >
                    <EditPencil style={{ fontSize: "18px" }} />
                  </div>
                )}

                <div className=" w-[30px] h-[30px] flex justify-center  items-center cursor-pointer" onClick={onClose}>
                  <NewCancel />
                </div>
              </div>
            </div>

            <div
              // ref={popupRef}
              className=" bg-white p-4 grow min-h-0 flex flex-col"
            >
              <div className="pb-4">
                {/* <Avatar sx={{ bgcolor: deepPurple[500], width: 86, height: 86, fontSize: "40px" }}>
                {getInitials(user?.name)}
              </Avatar> */}

                <div className=" space-y-2 ">
                  <h3 className="font-medium text-[#1D4469] text-lg ">{getName(user?.name)}</h3>
                  <div className="flex items-center space-x-2 group">
                    <span>
                      <Mail />
                    </span>
                    <label className="font-normal text-[#E95F56] text-base">{getName(user?.email)}</label>
                    {user?.email && (
                      <span className=" invisible group-hover:visible px-2">
                        <CopyIconComponent copyValue={user?.email} />
                      </span>
                    )}
                  </div>
                  <div className="flex space-x-2 group">
                    <span>
                      <Phone />
                    </span>
                    <label className="font-normal text-[#2999BC] text-base">{getName(user?.mobile)}</label>
                    {user?.mobile && (
                      <span className=" invisible group-hover:visible px-2">
                        {" "}
                        <CopyIconComponent copyValue={user?.mobile} />{" "}
                      </span>
                    )}
                  </div>

                  <div
                    className="flex space-x-2 cursor-pointer"
                    onClick={() => fetchDataCustomerAccess(manager?.uuid, token)}
                  >
                    <span className="cursor-pointer">
                      <RepotingManager />
                    </span>
                    <label className="font-normal text-[#1D4469] text-base cursor-pointer ">
                      {getName(manager?.name)}
                    </label>
                  </div>
                </div>
              </div>
              <div className=" mb-2 flex flex-col gap-4 pt-1">
                <div className="relative flex gap-8 border-b-2 border-[#E9EDF0]">
                  <button
                    onClick={() => toggleState("userInfo")}
                    className={`relative pb-2 text-lg  transition-colors ${
                      userInfo
                        ? "text-[#1D4469] after:absolute after:left-0 after:bottom-[-2px]  after:w-full after:h-0.5 after:bg-[#1D4469] font-semibold"
                        : "text-[#848687] font-normal"
                    }`}
                  >
                    User Info
                  </button>

                  {/* <button
                    onClick={() => toggleState("teamOpen")}
                    className={`relative pb-2 text-lg transition-colors ${
                      teamOpen
                        ? "text-[#1D4469] after:absolute after:left-0 after:bottom-[-2px] after:w-full after:h-0.5 after:bg-[#1D4469] font-semibold"
                        : "text-[#848687] font-normal"
                    }`}
                  >
                    Team
                  </button> */}
                </div>

                {userInfo && (
                  <div className="">
                    {console.log(user, "hellouserrr")}

                    <div className="flex flex-col gap-3">
                      {[
                        // { label: "Gender :", value: getName(user?.gender) },
                        // { label: "Date of Birth :", value: user?.dob ? moment(getName(user?.dob)).format("ll") : "-" }, // date format will be - June 23, 2024
                        { label: "Designation :", value: getName(user?.designation) },
                        { label: "Department :", value: getName(user?.department) },
                        { label: "Reporting To :", value: getName(manager?.name ? manager.name : "Self") },
                        // {
                        //   label: "Date of Joining :",
                        //   value: user?.doj ? moment(getName(user?.doj)).format("ll") : "-",
                        // },
                        // { label: "Country :", value: getName(user?.country) },
                      ].map((item, index) => (
                        <div key={index} className="flex  w-full">
                          <p className="font-normal text-base text-[#5E5E5E] w-[140px]">{item.label}</p>
                          <label className="font-normal text-base text-[#2C495D]">{item.value}</label>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
              {teamOpen && (
                <div className="flex flex-col grow min-h-0 ">
                  <div class={`flex flex-col gap-4 h-full`}>
                    {/* {manager && (
                      <>
                        <div
                          className="flex justify-center"
                          onClick={() => fetchDataCustomerAccess(manager?.id, token)}
                        >
                          <TeamCard name={manager?.name} designation={manager?.designation} />
                        </div>
                      </>
                    )} */}
                    {user && (
                      <div className="flex justify-center">
                        {console.log(user, "teamuser")}
                        <TeamCard
                          name={user?.name}
                          designation={user?.designation}
                          leader
                          // onClick={() => fetchDataCustomerAccess(user?.uuid, token)}
                        />
                      </div>
                    )}
                    <div className="mt-1 grid grid-cols-3 gap-2 justify-center overflow-auto px-1 thinscrollbar overflow-x-hidden">
                      {console.log(team, "teamarray")}

                      {Boolean(team?.length) ? (
                        team.map((eachMember) => (
                          <TeamCard
                            name={eachMember.name}
                            designation={eachMember.designation}
                            onClick={() => fetchDataCustomerAccess(eachMember.uuid, token)}
                          />
                        ))
                      ) : (
                        <p className="text-center"></p>
                      )}
                    </div>
                  </div>
                  {/* <div className="text-base font-normal mt-3 text-535252 inline-block border-b cursor-pointer  border-535252 py-0 "> Less More</div> */}
                </div>
              )}
            </div>
          </div>
        </CustomDrawer>
      )}
    </>
  );
};

export default CustomerShowDetails;
